import { render, staticRenderFns } from "./GptIcon.vue?vue&type=template&id=9272d88e&scoped=true"
import script from "./GptIcon.vue?vue&type=script&lang=js"
export * from "./GptIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9272d88e",
  null
  
)

export default component.exports